/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { getTroyUrl } from "constants/domain"

export const sellerCenterApiReducerPath = "sellerCenterApi" as const

export const getSellerCenterApiUrl = (): string =>
  `${getTroyUrl()}/ecommerce/sellercenter`

export const sellerCenterEndpoints = {
  listProducts: "/v1/products",
  createProduct: "/v1/products",
  getProduct: (productSpuID: string) => `/v1/products/${productSpuID}`,
  getItemsByProductIDs: "/v1/products/items",
  getVideoUploadUrl: "/v1/products/videos/uploadurl",
  getVideoStatus: "/v1/products/videos/status",
  listCategoryTreeNodes: "/v1/category-tree/nodes",
  listCategories: "/v1/categories",
  listProductsByCategoryID: (categoryID: string) =>
    `/v1/categories/${categoryID}/products`,
  createCategory: "/v1/categories",
  updateCategory: (categoryID: string) => `/v1/categories/${categoryID}`,
  updateCategoryProducts: (categoryID: string) =>
    `/v1/categories/${categoryID}/products`,
  batchUpdateCategories: "/v1/batch/categories",
  updateProductStatus: "/v1/products/status",
} as const

export const SELLER_CENTER_CACHE_TAGS = {
  products: "products",
  categories: "categories",
  items: "items",
} as const
